/**
 * Program Summary Service
 * Register Angular Service for the Status Sumamry
 *
 * @package:  frictionlessdigital/dashboard
 * @version:  2.7
 * @author:   Cyrill N KALITA
 * @return    Resource
 */
import angular from 'angular';

angular.module('flsServices').factory('ProgramSummary', ['$resource', function($resource){
    return $resource('/api/aggregate/v1/program-status-summary');
}]);
